// import React, { useState, useEffect } from 'react';
// import './SMA.css';
// import { useNavigate } from 'react-router-dom';
// import Toast from '../../Toast';
// import logoImage from '../../../resources/1000028180.jpeg';

// export default function FeelingConfident() {
//   const questions = [
//     'I believe I can play well in my sport.',
//     'I feel happy and excited when I am playing.',
//     'I trust myself to do my best in every game.',
//     'Even if I make a mistake, I know I can do better next time.',
//     'I feel strong and ready before a game starts.',
//   ];

//   const [responses, setResponses] = useState({});
//   const [showToast, setShowToast] = useState(false);
//   const [toastMessage, setToastMessage] = useState('');
//   const [toastType, setToastType] = useState('warning');
//   const navigate = useNavigate();

//   useEffect(() => {
//     const savedData = JSON.parse(localStorage.getItem('smaU10') || '{}');
//     if (savedData.confidence && Array.isArray(savedData.confidence)) {
//       const savedResponses = {};
//       savedData.confidence.forEach((value, index) => {
//         savedResponses[index] = Number(value);
//       });
//       setResponses(savedResponses);
//     }
//   }, []);

//   const handleSelect = (index, value) => {
//     const updated = { ...responses, [index]: value };
//     setResponses(updated);

//     const confidenceArray = Object.keys(updated)
//     .sort((a, b) => parseInt(a) - parseInt(b))
//     .map((key) => updated[key]);

//     const existing = JSON.parse(localStorage.getItem('smaU10') || '{}');
//     localStorage.setItem('smaU10', JSON.stringify({
//       ...existing,
//       confidence: confidenceArray,
//     }));
//   };

//   const handleNext = () => {
//     if (questions.some((_, idx) => !responses[idx])) {
//       setToastMessage('Please answer all questions before proceeding.');
//       setToastType('warning');
//       setShowToast(true);
//       return;
//     }
//     navigate('/NervousFeeling', { replace: true });
//   };

//   const currentSection = 3;
//   const totalSections = 4;

//   return (
//     <div style={{
//       minHeight: '100vh',
//       background: `linear-gradient(to top left, #2AA7A1 -25.98%, #E0F7F4 66.42%)`,
//       fontFamily: 'Poppins, sans-serif',
//     }}>
//       <header className="dashboard-header" style={{position: 'static'}}>
//         <div className="header-content">
//           <div className="header-logo-container">
//             <img 
//               src={logoImage} 
//               alt="Power Mind Metrics Logo" 
//               style={{ height: '50px', width: '50px', marginRight: '10px' }}
//             />
//             <h1 className="header-logo">Power Mind Metrics</h1>
//           </div>
//           <nav className="header-nav">
//             <button className="nav-link" onClick={() => navigate('/profile')}>Profile</button>
//             <button className="nav-link" onClick={() => navigate('/logout')}>Logout</button>
//           </nav>
//         </div>
//       </header>
//       <div style={{
//         minHeight: 'calc(100vh - 64px)',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         marginTop: 64,
//       }}>
//         <div style={{
//           background: '#fff',
//           borderRadius: 8,
//           boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
//           width: 1028,
//           height: 930,
//           padding: 24,
//           opacity: 1,
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'stretch',
//           marginBottom: 50,
//         }}>
//           <h1 style={{fontWeight: 700, fontSize: 32, color: '#444', marginBottom: 16, textAlign: 'center'}}>SMA U10 Assessment</h1>
//           <div style={{width: '100%', marginBottom: 24}}>
//             <div style={{fontWeight: 500, fontSize: 20, marginBottom: 8}}>Step 3 of 4: <span style={{fontWeight: 600}}>Feeling Confident 💪</span></div>
//             <div style={{display: 'flex', flexDirection: 'row', gap: 16, width: '100%', marginTop: 8, marginBottom: 8}}>
//               {[1,2,3,4].map((step) => (
//                 <div
//                   key={step}
//                   style={{
//                     flex: 1,
//                     height: 10,
//                     borderRadius: 6,
//                     background: currentSection >= step ? '#2AA7A1' : '#e0e0e0',
//                     transition: 'background 0.3s',
//                   }}
//                 />
//               ))}
//             </div>
//           </div>
//           {questions.map((question, index) => (
//             <div key={index} style={{marginBottom: 24, width: '100%'}}>
//               <div style={{fontWeight: 600, fontSize: 18, marginBottom: 8, textAlign: 'left'}}>{question}</div>
//               <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: 4, width: '100%'}}>
//                 {[1, 2, 3].map((value) => (
//                   <span key={value} style={{fontSize: 13, color: '#444', width: 180, textAlign: 'center'}}>
//                     {value === 1 ? 'No, not really' : value === 2 ? 'Sometimes' : 'Yes, a lot'}
//                   </span>
//                 ))}
//               </div>
//               <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%'}}>
//                 {[1,2,3].map((value) => (
//                   <label key={value} style={{width: 180, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
//                     <input
//                       type="radio"
//                       name={`q${index}`}
//                       value={value}
//                       checked={responses[index] === value}
//                       onChange={() => handleSelect(index, value)}
//                       // style={{width: 18, height: 18, accentColor: '#2AA7A1'}}
//                       style={{width: 18, height: 18, accentColor: ' rgb(15, 148, 150)',}}
//                     />
//                   </label>
//                 ))}
//               </div>
//             </div>
//           ))}
//           <div style={{display: 'flex', width: '100%', justifyContent: 'space-between', marginTop: 24}}>
//             <button
//               type="button"
//               onClick={() => navigate('/dashboard')}
//               style={{
//                 border: '2px solid #2aa7a1',
//                 background: '#fff',
//                 color: '#2aa7a1',
//                 borderRadius: 8,
//                 fontWeight: 500,
//                 fontSize: 16,
//                 fontFamily: 'Poppins, sans-serif',
//                 cursor: 'pointer',
//                 transition: 'background 0.2s, color 0.2s',
//                 height: 40,
//                 width: 107,
//               }}
//             >
//               Cancel
//             </button>
//             <button
//               type="button"
//               onClick={handleNext}
//               style={{
//                 border: 'none',
//                 background: '#2aa7a1',
//                 color: '#fff',
//                 borderRadius: 8,
//                 fontWeight: 500,
//                 fontSize: 16,
//                 fontFamily: 'Poppins, sans-serif',
//                 cursor: 'pointer',
//                 transition: 'background 0.2s',
//                 height: 40,
//                 width: 170,
//               }}
//             >
//               Next Section
//             </button>
//           </div>
//           {showToast && (
//             <Toast
//               message={toastMessage}
//               type={toastType}
//               onClose={() => setShowToast(false)}
//             />
//           )}
//         </div>
//       </div>
      
//       {/* Footer */}
//       <div style={{
//         position: 'fixed',
//         bottom: 0,
//         left: 0,
//         right: 0,
//         background: 'rgba(255, 255, 255, 0.95)',
//         backdropFilter: 'blur(10px)',
//         borderTop: '1px solid rgba(0, 0, 0, 0.1)',
//         padding: '12px 0',
//         textAlign: 'center',
//         fontFamily: 'Poppins, sans-serif',
//         zIndex: 100
//       }}>
//         <p style={{
//           margin: 0,
//           fontSize: '14px',
//           color: 'rgba(75, 75, 75, 0.8)',
//           fontWeight: 400
//         }}>
//           © 2025 All rights reserved Power Mind Metrics
//         </p>
//       </div>
//     </div>
//   );
// }
// import React, { useState, useEffect } from 'react';
// import './SMA.css';
// import { useNavigate } from 'react-router-dom';
// import Toast from '../../Toast';
// import logoImage from '../../../resources/1000028180.jpeg';

// export default function StayingFocused() {
//   const questions = [
//     'I listen carefully when my coach gives instructions.',
//     'I try to concentrate during games and not get distracted.',
//     'I remember what my coach tells me and use it in the game.',
//     'I stay focused even when there is noise or cheering.',
//     'I can quickly get back on track if I get distracted.',
//   ];

//   const [responses, setResponses] = useState({});
//   const [showToast, setShowToast] = useState(false);
//   const [toastMessage, setToastMessage] = useState('');
//   const [toastType, setToastType] = useState('warning');
//   const navigate = useNavigate();

//   useEffect(() => {
//     const savedData = JSON.parse(localStorage.getItem('smaU10') || '{}');
//     if (savedData.staying_focused && Array.isArray(savedData.staying_focused)) {
//       const savedResponses = {};
//       savedData.staying_focused.forEach((value, index) => {
//         savedResponses[index] = Number(value);
//       });
//       setResponses(savedResponses);
//     }
//   }, []);

//   const handleSelect = (index, value) => {
//     const updated = { ...responses, [index]: value };
//     setResponses(updated);

//     const staying_focusedArray = Object.keys(updated)
//       .sort((a, b) => parseInt(a) - parseInt(b))
//       .map((key) => updated[key]);

//     const existing = JSON.parse(localStorage.getItem('smaU10') || '{}');
//     localStorage.setItem('smaU10', JSON.stringify({
//       ...existing,
//       staying_focused: staying_focusedArray,
//     }));
//   };

//   const handleNext = () => {
//     if (questions.some((_, idx) => !responses[idx])) {
//       setToastMessage('Please answer all questions before proceeding.');
//       setToastType('warning');
//       setShowToast(true);
//       return;
//     }
//     navigate('/Confident', { replace: true });
//   };

//   const handlePrev = () => {
//     navigate('/Handling', { replace: true });
//   };

//   const currentSection = 2;
//   const totalSections = 4;

//   return (
//     <div style={{
//       minHeight: '100vh',
//       background: `linear-gradient(to top left, #2AA7A1 -25.98%, #E0F7F4 66.42%)`,
//       fontFamily: 'Poppins, sans-serif',
//     }}>
//       <header className="dashboard-header" style={{position: 'static'}}>
//         <div className="header-content">
//           <div className="header-logo-container">
//             <img 
//               src={logoImage} 
//               alt="Power Mind Metrics Logo" 
//               style={{ height: '50px', width: '50px', marginRight: '10px' }}
//             />
//             <h1 className="header-logo">Power Mind Metrics</h1>
//           </div>
//           <nav className="header-nav">
//             <button className="nav-link" onClick={() => navigate('/profile')}>Profile</button>
//             <button className="nav-link" onClick={() => navigate('/logout')}>Logout</button>
//           </nav>
//         </div>
//       </header>
//       <div style={{
//         minHeight: 'calc(100vh - 64px)',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         marginTop: 64,
//       }}>
//         <div
//           style={
//             window.innerWidth > 600
//               ? {
//                   background: '#fff',
//                   borderRadius: 8,
//                   boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
//                   width: 1028,
//                   height: 930,
//                   padding: 24,
//                   opacity: 1,
//                   display: 'flex',
//                   flexDirection: 'column',
//                   alignItems: 'stretch',
//                   marginBottom: 50,
//                 }
//               : {
//                   background: '#fff',
//                   borderRadius: '1.2rem',
//                   boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
//                   width: '100vw',
//                   maxWidth: '98vw',
//                   minWidth: 0,
//                   padding: '1.2rem 0.7rem 1.5rem 0.7rem',
//                   boxSizing: 'border-box',
//                   margin: 0,
//                   marginBottom: '80px',
//                 }
//           }
//         >
//           <h1 style={{fontWeight: 700, fontSize: 32, color: '#444', marginBottom: 16, textAlign: 'center'}}>SMA U10 Assessment</h1>
//           <div style={{width: '100%', marginBottom: 24}}>
//             <div style={{fontWeight: 500, fontSize: 20, marginBottom: 8}}>Step 2 of 4: <span style={{fontWeight: 600}}>Staying Focused 🧠</span></div>
//             <div style={{display: 'flex', flexDirection: 'row', gap: 16, width: '100%', marginTop: 8, marginBottom: 8}}>
//               {[1,2,3,4].map((step) => (
//                 <div
//                   key={step}
//                   style={{
//                     flex: 1,
//                     height: 10,
//                     borderRadius: 6,
//                     background: currentSection >= step ? '#2AA7A1' : '#e0e0e0',
//                     transition: 'background 0.3s',
//                   }}
//                 />
//               ))}
//             </div>
//           </div>
//           {questions.map((question, index) => (
//             <div key={index} style={{marginBottom: 24, width: '100%'}}>
//               <div style={{fontWeight: 600, fontSize: 18, marginBottom: 8, textAlign: 'left'}}>{question}</div>
//               {window.innerWidth > 600 ? (
//                 <>
//                   <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: 4, width: '100%'}}>
//                     {[1, 2, 3].map((value) => (
//                       <span key={value} style={{fontSize: 13, color: '#444', width: 180, textAlign: 'center'}}>
//                         {value === 1 ? 'No, not really' : value === 2 ? 'Sometimes' : 'Yes, a lot'}
//                       </span>
//                     ))}
//                   </div>
//                   <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%'}}>
//                     {[1,2,3].map((value) => (
//                       <label key={value} style={{width: 180, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
//                         <input
//                           type="radio"
//                           name={`q${index}`}
//                           value={value}
//                           checked={responses[index] === value}
//                           onChange={() => handleSelect(index, value)}
//                           style={{width: 18, height: 18, accentColor: ' rgb(15, 148, 150)',}}
//                         />
//                       </label>
//                     ))}
//                   </div>
//                 </>
//               ) : (
//                 (() => {
//                   // Mobile: options in pairs of two, with radio before label, using mtt20 classes
//                   const answerLabels = ['No, not really', 'Sometimes', 'Yes, a lot'];
//                   const pairs = [[1,2],[3]];
//                   return pairs.map((pair, rowIdx) => (
//                     <div key={rowIdx} className="mtt20-options-pair-row">
//                       {pair.map((value) => (
//                         <label key={value} className="mtt20-option-label">
//                           <input
//                             type="radio"
//                             name={`q${index}`}
//                             value={value}
//                             checked={responses[index] === value}
//                             onChange={() => handleSelect(index, value)}
//                             className="mtt20-radio"
//                           />
//                           <span className="mtt20-option-label-text">{answerLabels[value-1]}</span>
//                         </label>
//                       ))}
//                     </div>
//                   ));
//                 })()
//               )}
//             </div>
//           ))}
//           <div style={{display: 'flex', width: '100%', justifyContent: 'space-between', marginTop: 24}}>
//             <button
//               type="button"
//               onClick={() => navigate('/dashboard')}
//               style={{
//                 border: '2px solid #2aa7a1',
//                 background: '#fff',
//                 color: '#2aa7a1',
//                 borderRadius: 8,
//                 fontWeight: 500,
//                 fontSize: 16,
//                 fontFamily: 'Poppins, sans-serif',
//                 cursor: 'pointer',
//                 transition: 'background 0.2s, color 0.2s',
//                 height: 40,
//                 width: 107,
//               }}
//             >
//               Cancel
//             </button>
//             <button
//               type="button"
//               onClick={handleNext}
//               style={{
//                 border: 'none',
//                 background: '#2aa7a1',
//                 color: '#fff',
//                 borderRadius: 8,
//                 fontWeight: 500,
//                 fontSize: 16,
//                 fontFamily: 'Poppins, sans-serif',
//                 padding: '8px 16px',
//                 cursor: 'pointer',
//                 transition: 'background 0.2s',
//                 height: 40,
//                 width: 170,
//               }}
//             >
//               Next Section
//             </button>
//           </div>
//           {showToast && (
//             <Toast
//               message={toastMessage}
//               type={toastType}
//               onClose={() => setShowToast(false)}
//             />
//           )}
//         </div>
//       </div>
      
//       {/* Footer */}
//       <div style={{
//         position: 'fixed',
//         bottom: 0,
//         left: 0,
//         right: 0,
//         background: 'rgba(255, 255, 255, 0.95)',
//         backdropFilter: 'blur(10px)',
//         borderTop: '1px solid rgba(0, 0, 0, 0.1)',
//         padding: '12px 0',
//         textAlign: 'center',
//         fontFamily: 'Poppins, sans-serif',
//         zIndex: 100
//       }}>
//         <p style={{
//           margin: 0,
//           fontSize: '14px',
//           color: 'rgba(75, 75, 75, 0.8)',
//           fontWeight: 400
//         }}>
//           © 2025 All rights reserved Power Mind Metrics
//         </p>
//       </div>
//     </div>
//   );
// }
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './SMA.css';
import Toast from '../../Toast';
import logoImage from '../../../resources/1000028180.jpeg';
import { FiMenu } from 'react-icons/fi';

export default function FeelingConfident() {
  const questions = [
    'I believe I can play well in my sport.',
    'I feel happy and excited when I am playing.',
    'I trust myself to do my best in every game.',
    'Even if I make a mistake, I know I can do better next time.',
    'I feel strong and ready before a game starts.',
  ];

  const [responses, setResponses] = useState({});
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastType, setToastType] = useState('warning');
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem('smaU10') || '{}');
    if (savedData.confidence && Array.isArray(savedData.confidence)) {
      const savedResponses = {};
      savedData.confidence.forEach((value, index) => {
        savedResponses[index] = Number(value);
      });
      setResponses(savedResponses);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSelect = (index, value) => {
    const updated = { ...responses, [index]: value };
    setResponses(updated);

    const confidenceArray = Object.keys(updated)
      .sort((a, b) => parseInt(a) - parseInt(b))
      .map((key) => updated[key]);

    const existing = JSON.parse(localStorage.getItem('smaU10') || '{}');
    localStorage.setItem('smaU10', JSON.stringify({
      ...existing,
      confidence: confidenceArray,
    }));
  };

  const handleNext = () => {
    if (questions.some((_, idx) => !responses[idx])) {
      setToastMessage('Please answer all questions before proceeding.');
      setToastType('warning');
      setShowToast(true);
      return;
    }
    navigate('/NervousFeeling', { replace: true });
  };

  const handlePrev = () => {
    navigate('/Focused', { replace: true });
  };

  const currentSection = 3;
  const totalSections = 4;

  return (
    <div style={{
      minHeight: '100vh',
      background: `linear-gradient(to top left, #2AA7A1 -25.98%, #E0F7F4 66.42%)`,
      fontFamily: 'Poppins, sans-serif',
    }}>
      <header className="dashboard-header" style={{position: 'static'}}>
        <div className="header-content">
          <div className="header-logo-container">
                                  <img
                        src={logoImage}
                        alt="Power Mind Metrics Logo"
                        style={{ height: "90px", width: "100px", marginRight: "10px" }}
                      />
            <h1 className="header-logo" style={{ whiteSpace: window.innerWidth <= 600 ? 'nowrap' : undefined, fontSize: window.innerWidth <= 600 ? 22 : undefined }}>Power Mind Metrics</h1>
          </div>
          <nav className="header-nav desktop-nav">
            <button className="nav-link" onClick={() => navigate('/profile')}>Profile</button>
            <button className="nav-link" onClick={() => navigate('/logout')}>Logout</button>
          </nav>
          <div className="mobile-nav-menu">
            <button className="hamburger-btn" onClick={() => setMobileMenuOpen(v => !v)}>
              <FiMenu size={28} />
            </button>
            {mobileMenuOpen && (
              <div className="mobile-nav-dropdown">
                <button className="nav-link" onClick={() => { setMobileMenuOpen(false); navigate('/profile'); }}>Profile</button>
                <button className="nav-link" onClick={() => { setMobileMenuOpen(false); navigate('/logout'); }}>Logout</button>
              </div>
            )}
          </div>
        </div>
      </header>
      <div style={{
        minHeight: 'calc(100vh - 64px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 64,
      }}>
        <div
          style={
            window.innerWidth > 600
              ? {
                  background: '#fff',
                  borderRadius: 8,
                  boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                  width: 1028,
                  height: 930,
                  padding: 24,
                  opacity: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'stretch',
                  marginBottom: 50,
                }
              : {
                  background: '#fff',
                  borderRadius: '1.2rem',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                  width: '100vw',
                  maxWidth: '98vw',
                  minWidth: 0,
                  padding: '1.2rem 0.7rem 1.5rem 0.7rem',
                  boxSizing: 'border-box',
                  margin: 0,
                  marginBottom: '80px',
                }
          }
        >
          <h1 style={{fontWeight: 700, fontSize: 32, color: '#444', marginBottom: 16, textAlign: 'center'}}>SMA U10 Assessment</h1>
          <div style={{width: '100%', marginBottom: 24}}>
            <div style={{fontWeight: 500, fontSize: 20, marginBottom: 8}}>Step 3 of 4: <span style={{fontWeight: 600}}>Feeling Confident 💪</span></div>
            <div style={{display: 'flex', flexDirection: 'row', gap: 16, width: '100%', marginTop: 8, marginBottom: 8}}>
              {[1,2,3,4].map((step) => (
                <div
                  key={step}
                  style={{
                    flex: 1,
                    height: 10,
                    borderRadius: 6,
                    background: currentSection >= step ? '#2AA7A1' : '#e0e0e0',
                    transition: 'background 0.3s',
                  }}
                />
              ))}
            </div>
          </div>
          {questions.map((question, index) => (
            <div key={index} style={{marginBottom: 24, width: '100%'}}>
              <div style={{fontWeight: 600, fontSize: 18, marginBottom: 8, textAlign: 'left'}}>{question}</div>
              {window.innerWidth > 600 ? (
                <>
                  <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: 4, width: '100%'}}>
                    {[1, 2, 3].map((value) => (
                      <span key={value} style={{fontSize: 13, color: '#444', width: 180, textAlign: 'center'}}>
                        {value === 1 ? 'No, not really' : value === 2 ? 'Sometimes' : 'Yes, a lot'}
                      </span>
                    ))}
                  </div>
                  <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%'}}>
                    {[1,2,3].map((value) => (
                      <label key={value} style={{width: 180, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <input
                          type="radio"
                          name={`q${index}`}
                          value={value}
                          checked={responses[index] === value}
                          onChange={() => handleSelect(index, value)}
                          style={{width: 18, height: 18, accentColor: ' rgb(15, 148, 150)',}}
                        />
                      </label>
                    ))}
                  </div>
                </>
              ) : (
                (() => {
                  // Mobile: options in pairs of two, with radio before label, using mtt20 classes
                  const answerLabels = ['No, not really', 'Sometimes', 'Yes, a lot'];
                  const pairs = [[1,2],[3]];
                  return pairs.map((pair, rowIdx) => (
                    <div key={rowIdx} className="mtt20-options-pair-row">
                      {pair.map((value) => (
                        <label key={value} className="mtt20-option-label">
                          <input
                            type="radio"
                            name={`q${index}`}
                            value={value}
                            checked={responses[index] === value}
                            onChange={() => handleSelect(index, value)}
                            className="mtt20-radio"
                          />
                          <span className="mtt20-option-label-text">{answerLabels[value-1]}</span>
                        </label>
                      ))}
                    </div>
                  ));
                })()
              )}
            </div>
          ))}
          <div style={{display: 'flex', width: '100%', justifyContent: 'space-between', marginTop: 24}}>
            <button
              type="button"
              onClick={() => navigate('/dashboard')}
              style={{
                border: '2px solid #2aa7a1',
                background: '#fff',
                color: '#2aa7a1',
                borderRadius: 8,
                fontWeight: 500,
                fontSize: 16,
                fontFamily: 'Poppins, sans-serif',
                cursor: 'pointer',
                transition: 'background 0.2s, color 0.2s',
                height: 40,
                width: 107,
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleNext}
              style={{
                border: 'none',
                background: '#2aa7a1',
                color: '#fff',
                borderRadius: 8,
                fontWeight: 500,
                fontSize: 16,
                fontFamily: 'Poppins, sans-serif',
                padding: '8px 16px',
                cursor: 'pointer',
                transition: 'background 0.2s',
                height: 40,
                width: 170,
              }}
            >
              Next Section
            </button>
          </div>
          {showToast && (
            <Toast
              message={toastMessage}
              type={toastType}
              onClose={() => setShowToast(false)}
            />
          )}
        </div>
      </div>
      
      {/* Footer */}
      <div style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
        padding: '12px 0',
        textAlign: 'center',
        fontFamily: 'Poppins, sans-serif',
        zIndex: 100
      }}>
        <p style={{
          margin: 0,
          fontSize: '14px',
          color: 'rgba(75, 75, 75, 0.8)',
          fontWeight: 400
        }}>
          © 2025 All rights reserved Power Mind Metrics
        </p>
      </div>
    </div>
  );
}
